<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="机构名称" v-model="insName"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="devId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input
          placeholder="个人超级管理员手机号码"
          v-model="mobile"
        ></el-input>
      </el-col>

      <el-col :span="10">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-table
      row-key="activeId"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column label="机构名称/个人管理手机号">
        <template slot-scope="scope">
          <el-checkbox
            :disabled="scope.row.id"
            @change="handleCheckChange(scope.row.activeId, $event)"
            v-model="radio[scope.row.activeId]"
          ></el-checkbox>
          {{ scope.row.ownerName || scope.row.activeId }}
        </template>
      </el-table-column>
      <el-table-column label="个人/机构">
        <template slot-scope="scope">
          {{ scope.row.userType == 0 ? "机构" :scope.row.activeId && !scope.row.ownerName ? "": "个人"}}

        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onDelete('sel',scope.row.activeId)"
            >删除</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
      <el-button
        type="success"
        style="margin-left:100px"
        @click="add('list', radio)"
        >添加</el-button
      >
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
   name:'CPAddDevice',
   props: {
    apiHost:{
      path:'canpan',
      urlQuery:"?isCP=true"
    }
   },
  data() {
    return {
      pagin: {
        pageNum: 1,
        size: 10,
        isDefaultPageSizes: true,
        total: 0,
      },
      insName: "",
      devId: "",
      mobile: "",
      radio: {},
      preRadio: {},
      tableData: [],
      multipleSelection: [],
    };
  },

  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        page: this.pagin.pageNum,
        limit: this.pagin.size,
        insName: this.insName,
       
        mobile: this.mobile,
        mchId: +this.$route.params.id,
      };
      if(this.devId){
        params.devId = +this.devId;
      }
      this.radio = {};
      console.log(this.apiHost.path, '83838')
      this.$http.post(`/${this.apiHost.path}/merchant/devPage`, params).then((results) => {
        this.tableData = this.parseList(results["data"]["data"]["records"]);
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    add(type, value) {
      let addIds = [];
      let disIds = [];
      this.tableData.forEach((item, idx) => {
        if (item.children) {
          item.children.forEach((_item) => {
            if (_item.isDis) {
              disIds.push(_item.activeId);
            }
          });
        }
      });
      
      if (type === "list") {
        Object.keys(value).forEach((key) => {
          if (!key.includes("type:") && value[key] && !disIds.includes(key)){
            addIds.push(key);
          }
        });
      }
      let data = [];
      this.tableData.forEach((item) => {
        if (item.children) {
          item.children.forEach((_item, idx) => {
            if (addIds.includes(_item.activeId + "")) {
              data.push({
                userType: item.userType,
                devId: _item.activeId,
                ownerId: item.ownerId,
                mchId: this.$route.params.id,
              });
            }
          });
        }
      });
      console.log('data',addIds,disIds,data);

      if(!addIds.length){
        alert(
          '请先选择要添加的设备'
        )
        return
      }
      if (confirm("确定要添加吗？")) {
        this.$http.post(`/${this.apiHost.path}/merchant/devAdd`, data).then((rs) => {
          if (rs.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$router.push("/api/index/device/" + this.$route.params.id + this.apiHost.urlQuery);
          } else {
            this.$message({
              message: rs.data.message,
              type: "error",
            });
          }
        });
      }
    },
    handleCheckChange(id, v) {
      const parent = this.tableData.filter((item) => item.activeId === id)[0];
      let copyRadio = { ...this.radio };
      if (parent) {
        // 没有children不处理父节点
        if (!parent.children) {
          return;
        }
        let ids = parent.children.map((item) => item.activeId);
        ids.forEach((id) => {
          copyRadio[id] = v;
        });
        console.log("copyRadio[", copyRadio);
        this.radio = copyRadio;
        return;
      }
      let _Parent = this.getParent(id, this.tableData);

      if (v) {
        let isAllSelect = true;
        _Parent.children.map((item) => {
          if (
            (!copyRadio[item.activeId] || copyRadio[item.activeId] === false) &&
            isAllSelect
          ) {
            isAllSelect = false;
          }
        });
        if (isAllSelect) {
          copyRadio[_Parent.activeId] = true;
        }
      } else {
        console.log(11);
        copyRadio[_Parent.activeId] = false;
      }
      this.radio = copyRadio;
    },
    getParent(id, list) {
      let parent = null;
      list.forEach((item) => {
        if (item.children) {
          item.children.forEach((_item) => {
            if (_item.activeId === id) {
              parent = item;
            }
          });
        }
      });
      return parent;
    },
    parseList(list) {
      const _list = [...list];
      _list.map((item, idx) => {
        item.activeId = `type:` + idx + 1;
        if (item.devList) {
          let isActiveAll = true;
          item.children = item.devList.map((_item) => {
            _item.activeId = _item.devId;
            if (_item.id) {
              _item.isDis = true;
              this.radio[_item.devId] = true;
            } else {
              isActiveAll = false;
            }
            return _item;
          });
          if (isActiveAll) {
            item.id = true;
            this.radio[`type:` + idx + 1] = true;
          }
          delete item.devList;
        }
      });
      return _list;
    },
    diffObj(newValue, oldValue) {
      const diff = {};

      for (let key in newValue) {
        if (newValue.hasOwnProperty(key)) {
          if (
            !oldValue.hasOwnProperty(key) ||
            oldValue[key] !== newValue[key]
          ) {
            diff[key] = newValue[key];
          }
        }
      }

      for (let key in oldValue) {
        if (oldValue.hasOwnProperty(key) && !newValue.hasOwnProperty(key)) {
          diff[key] = undefined;
        }
      }

      return Object.keys(diff).map((item) => [item, diff[item]])[0];
    },
  },
  components: { Pagination },
};
</script>
